import getComplementSequenceString from "./getComplementSequenceString";
import tidyUpSequenceData from "./tidyUpSequenceData";
import getSequenceDataBetweenRange from "./getSequenceDataBetweenRange";
export default function getComplementSequenceAndAnnotations(pSeqObj, options = {}) {
  const seqObj = tidyUpSequenceData(
    getSequenceDataBetweenRange(pSeqObj, options.range),
    options
  );
  const newSeqObj = Object.assign({}, seqObj, {
    sequence: getComplementSequenceString(seqObj.sequence, seqObj.isRna)
  });
  return tidyUpSequenceData(newSeqObj, {
    doNotRemoveInvalidChars: true,
    ...options
  });
}
